<template lang="pug">
router-link(v-bind:to='{ name: "News", params: { id: item.id } }')
	.item_card_news
		.image(v-bind:style='{ backgroundImage: "url(" + imageUrl + ")" }')
		.text
			h5.date {{ item.datetime }}
			h3.title {{ item.title }}
			h4.desc {{ item.brief }}
</template>

<script>
export default {
	props: ['item'],
	computed: {
		imageUrl: function () {
			return process.env.VUE_APP_WP_IMAGE_PREFIX + this.item.image;
		},
	},
};
</script>

<style lang="stylus">
.item_card_news
	display: flex
	flex-wrap: wrap
	background-color: $color_dark
	border-radius: 15px
	border: 1px solid #082448
	margin-bottom: 1rem
	.image
		position: relative
		flex-basis: 30%
		background-size: cover
		background-position: center top
		border-radius: 15px 0 0 15px
		&:after
			content: ''
			position: absolute
			width: 100%
			height: 100%
			left: 0
			background: linear-gradient(270deg, #0B2E5B 0%, rgba(11, 46, 91, 0) 58.21%)
	.text
		padding: 1.25rem 2.5rem
		flex: 1
		.date
			text-align: left
			margin-bottom: 0.5rem
			color: $color_yellow
		.title, .desc
			display: -webkit-box
			-webkit-box-orient: vertical
			overflow: hidden
			text-overflow: ellipsis
			line-height: 24px
		.title
			-webkit-line-clamp: 2
			font-size: 1.125rem
			font-weight: 500
			text-align: justify
			margin-bottom: 1rem
			color: white
		.desc
			min-height: 72px
			-webkit-line-clamp: 3
			color: $color_light
			text-align: justify
	@media screen and (max-width: $screen-sm-max)
		.image
			flex-basis: 100%
			height: 220px
			border-radius: 15px 15px 0 0
			&:after
				background: linear-gradient(180deg, rgba(11, 46, 91, 0) 50%, #0B2E5B 100%)
				bottom: -1px
		.text
			padding: 24px
			.date
				margin-bottom: 4px
			.title
				-webkit-line-clamp: 3
				margin-bottom: 24px
			.desc
				-webkit-line-clamp: 2
</style>
